<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
         setTimeout(async function(){
                let respManufacturers = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {type:"TRUCK"}, `${Endpoints.parts.manufacturer.listByType}`)).data;
                if (respManufacturers.status==200){
                    payload.manufacturers = respManufacturers.results;
                 }
        }, 100);
    
        
    },
    methods:{
          filter: function(){

            if(this.truckerName) {
                alert('Deve escolher o caminhoneiro que aparece na lista para continuar');
                return;
            }

            $('#spinner').modal('toggle');            
            if(this.filters.manufacturer ==-1){
                this.titleToast = this.$t('string.msg.warning');
                this.messageToast = this.$t('string.msg.filter.select.required');
                $('#toast').modal('show');
            }
            else{
                let payload = this;
                payload.items = [];
                console.log('FILTERS', payload.filters);
                setTimeout(async function(){
                    let truck = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), payload.filters, `${Endpoints.trucks.listByType}`));
                    console.log(truck);
                    if (truck.status == 200){
                        payload.items = truck.data.results;
                        $('#spinner').modal('toggle');
                    }
                }, 100);
            }
        },
        clearFilter: function() {
            this.filters = {
                manufacturer: null,
                company: null,
                plate:null,
                status: 'ACTIVE',
                truckerName: null,
            }
            this.truckerName = null;
        },
        onChangeName: function(input) {
            let state = this;
            
            this.truckerName = input;
            
            if(input.length < 4) return [];
            return new Promise(
                (resolve, reject) => {
                    
                    Request.do(state, 'GET', Request.getDefaultHeader(state), { }, 
                        `${Endpoints.systemUsers.suggest}?term=${input}`,
                        (response)=>{  
                            console.log(response);
                            resolve(response);
                        },
                        (error)=>{//ERROR CALLBACK
                            console.log(error);
                            reject(error)
                        }
                    );

                }
            )

        },
        getResultValue(result) {
            return `${result.firstName || ''} ${result.lastName || ''}`;
        },
        submitFilter: function(term) {
            console.log(term)
            this.truckerName = null;
            this.filters.systemUser = term._id;
            this.filter();
        },
        selectItem: function(item){
            let copy = JSON.parse(JSON.stringify(item));
            
            if(copy.actualKM){
                copy.actualKM = Number(copy.actualKM)
            }

            if(copy.manufacturer && copy.manufacturer._id){
                copy.manufacturer = copy.manufacturer._id;
            }

            if(copy.model && copy.model._id){
                copy.model = copy.model._id;
            }

            if(copy.truckDriver && copy.truckDriver._id){
                copy.truckDriver = copy.truckDriver._id;
            }
            
            copy.oldDocumentPhotoURL = copy.documentPhotoURL;
            this.$emit('load-item', copy);
        },
         onChangePage(pageOfItems) {
            // update page of items
            this.pageOfItems = pageOfItems;
        },
        getPageNumbers: function(){
            return this.items.length/10;
        },
        fetchData(){
            // console.log(this.items.companyUser.company);
            this.json_data = this.items;
            return this.json_data;
        },
        camelize: Common.camelize,
    }
}
</script>
